import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const loginsRequest = createAction(types.LOGINS_REQUEST);
export const loginsSuccess = createAction(types.LOGINS_SUCCESS);
export const loginsFailure = createAction(types.LOGINS_FAILURE);

export const loginRequest = createAction(types.LOGIN_REQUEST);
export const loginSuccess = createAction(types.LOGIN_SUCCESS);
export const loginFailure = createAction(types.LOGIN_FAILURE);

export const createLoginRequest = createAction(types.CREATE_LOGIN_REQUEST);
export const createLoginSuccess = createAction(types.CREATE_LOGIN_SUCCESS);
export const createLoginFailure = createAction(types.CREATE_LOGIN_FAILURE);

export const updateLoginRequest = createAction(types.UPDATE_LOGIN_REQUEST);
export const updateLoginSuccess = createAction(types.UPDATE_LOGIN_SUCCESS);
export const updateLoginFailure = createAction(types.UPDATE_LOGIN_FAILURE);

export const verifyLoginRequest = createAction(types.VERIFY_LOGIN_REQUEST);
export const verifyLoginSuccess = createAction(types.VERIFY_LOGIN_SUCCESS);
export const verifyLoginFailure = createAction(types.VERIFY_LOGIN_FAILURE);

export const deleteLoginRequest = createAction(types.DELETE_LOGIN_REQUEST);
export const deleteLoginSuccess = createAction(types.DELETE_LOGIN_SUCCESS);
export const deleteLoginFailure = createAction(types.DELETE_LOGIN_FAILURE);

export const resetLogin = createAction(types.RESET_LOGIN);
export const resetLoginVerification = createAction(
  types.RESET_LOGIN_VERIFICATION,
);

export const setMfaLoginToken = createAction(types.SET_MFA_LOGIN_TOKEN);
export const deleteMfaLoginToken = createAction(types.DELETE_MFA_LOGIN_TOKEN);

export const setLoginCred = createAction(types.SET_LOGIN_CRED);
export const deleteLoginCred = createAction(types.DELETE_LOGIN_CRED);

export const setLegacyLoginDisabled = createAction(
  types.SET_LEGACY_LOGIN_DISABLED,
);

export default {
  resetLogin,
  resetLoginVerification,
  loginsRequest,
  loginsSuccess,
  loginsFailure,
  loginRequest,
  loginSuccess,
  loginFailure,
  createLoginRequest,
  createLoginSuccess,
  createLoginFailure,
  updateLoginRequest,
  updateLoginSuccess,
  updateLoginFailure,
  verifyLoginRequest,
  verifyLoginSuccess,
  verifyLoginFailure,
  deleteLoginRequest,
  deleteLoginSuccess,
  deleteLoginFailure,
  setMfaLoginToken,
  deleteMfaLoginToken,
  setLoginCred,
  deleteLoginCred,
  setLegacyLoginDisabled,
};
